import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Facebook, Twitter, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-foreground text-background mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-lg bg-primary flex items-center justify-center">
                <span className="text-primary-foreground font-bold text-sm">D+</span>
              </div>
              <span className="font-bold text-lg">DiagnoPlus</span>
            </div>
            <p className="text-sm text-background/70 leading-relaxed mb-4">
              India's trusted diagnostic center with over 500+ tests, NABL accredited labs, and home sample collection across 50+ cities.
            </p>
            <div className="flex gap-3">
              {[Facebook, Twitter, Instagram, Youtube].map((Icon, i) => (
                <a key={i} href="#" className="w-8 h-8 rounded-full bg-background/10 hover:bg-primary transition-colors flex items-center justify-center">
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-background">Quick Links</h4>
            <ul className="space-y-2 text-sm text-background/70">
              {[
                { label: "Lab Tests", href: "/tests" },
                { label: "Health Packages", href: "/packages" },
                { label: "Home Collection", href: "/home-collection" },
                { label: "Book Appointment", href: "/booking" },
                { label: "Track Report", href: "/my-bookings" },
              ].map(link => (
                <li key={link.href}>
                  <Link to={link.href} className="hover:text-primary transition-colors">{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Tests */}
          <div>
            <h4 className="font-semibold mb-4 text-background">Popular Tests</h4>
            <ul className="space-y-2 text-sm text-background/70">
              {["Complete Blood Count", "Lipid Profile", "Thyroid Profile", "HbA1c", "Vitamin D", "Liver Function Test"].map(test => (
                <li key={test}>
                  <Link to="/tests" className="hover:text-primary transition-colors">{test}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-background">Contact Us</h4>
            <ul className="space-y-3 text-sm text-background/70">
              <li className="flex items-start gap-2">
                <Phone className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <span>1800-123-4567 (Toll Free)<br />Mon–Sat: 7AM–9PM</span>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <span>support@diagnoplus.com</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="h-4 w-4 mt-0.5 text-primary shrink-0" />
                <span>Available in Bengaluru, Mumbai, Delhi, Chennai, Pune & more</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-background/50">
          <p>© 2025 DiagnoPlus Diagnostics Pvt. Ltd. All rights reserved.</p>
          <div className="flex gap-4">
            <a href="#" className="hover:text-background transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-background transition-colors">Terms of Service</a>
            <a href="#" className="hover:text-background transition-colors">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
